import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role",
  "use": "icon-role-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-role\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 85.333C270.933 85.333 85.333 270.933 85.333 512s185.6 426.667 426.667 426.667 426.667-185.6 426.667-426.667S753.067 85.333 512 85.333z m0 768c-188.459 0-341.333-152.875-341.333-341.333S323.541 170.667 512 170.667 853.333 323.541 853.333 512 700.459 853.333 512 853.333z\" p-id=\"2235\" /><path d=\"M512 256c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z m0 170.667c-23.467 0-42.667-19.2-42.667-42.667s19.2-42.667 42.667-42.667 42.667 19.2 42.667 42.667-19.2 42.667-42.667 42.667z\" p-id=\"2236\" /><path d=\"M512 554.667c-93.867 0-170.667 76.8-170.667 170.667v42.667h341.333v-42.667c0-93.867-76.8-170.667-170.667-170.667z m-85.333 170.667c14.933-42.667 54.613-72.533 85.333-72.533s70.4 29.867 85.333 72.533h-170.667z\" p-id=\"2237\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role.svg
// module id = cqqK
// module chunks = 29